var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-out"}},[_c('div',{staticClass:"loader"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/img/logo.svg"),"alt":"logo"}}),_c('div',{staticClass:"loading"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }